import { injectable, inject } from 'inversify';
import { QueryHandler } from '@/app/tracking/common';
import { QuestionSuspendDataStore } from './question-suspend-data-state-store';
import { QueryQuestionsTrackingQuery, QueryQuestionsTrackingQueryPayload } from '../api';

@injectable()
export class XApiQueryQuestionsQueryHandler implements QueryHandler<QueryQuestionsTrackingQuery> {

  constructor(
    @inject(QuestionSuspendDataStore)
    private questionStore: QuestionSuspendDataStore) {
  }

  public async execute(payload: QueryQuestionsTrackingQueryPayload) {

    const questions = await this.questionStore.query(payload.ids);
    return {
      questions: questions
    }
  }
}
